const StationFrom = {
  PRICETOOL: "pricetool",
  NONPRICETOOL: "non-pricetool",
  STOCQ: "stocq",
};

export default StationFrom;
